import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { Store, DeepPartial } from 'redux'
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'

import { ActionTypes } from './actions'
import reducer, { RootState } from './reducers'

let store: ReturnType<typeof configStore>

const configStore = (preloadedState?: DeepPartial<RootState>): Store<RootState, ActionTypes> =>
  configureStore({
    reducer,
    preloadedState: preloadedState as any,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  })

export const makeStore = (preloadedState?: DeepPartial<RootState>) => {
  store = configStore(preloadedState)
  return store
}

export type AppStore = ReturnType<typeof makeStore>
export type AppState = ReturnType<AppStore['getState']>
export type ReduxServerProps = { redux?: DeepPartial<RootState> }

export { store }
